import {NgModule} from '@angular/core';
import {ARTICLES} from '@infrastructure/http/article/articles';
import {HttpArticlesService} from '@infrastructure/http/article/http-articles.service';
import {CUSTOMERS} from '@infrastructure/http/customer/customers';
import {HttpCustomersService} from '@infrastructure/http/customer/http-customers.service';
import {HttpSalesOrdersService} from '@infrastructure/http/sales-order/http-sales-orders.service';
import {SALES_ORDERS} from '@infrastructure/http/sales-order/sales-orders';
import {AddSalesOrderPageComponent} from '@presentation/pages/texfab/sales-order/add/add-sales-order-page.component';
import {SalesOrderOverviewPageComponent} from '@presentation/pages/texfab/sales-order/overview/sales-order-overview-page.component';
import {salesOrderDataRouting} from '@presentation/pages/texfab/sales-order/sales-order.routing';
import {SharedModule} from '@shared/shared.module';
import {CanShowErrorForFormControlModule} from '@vdw/angular-component-library';
import {SelectArticleComponent} from './add/select-article/select-article.component';
import {SelectCustomerComponent} from './add/select-customer/select-customer.component';

@NgModule({
  imports: [SharedModule, salesOrderDataRouting, CanShowErrorForFormControlModule],
  providers: [
    {provide: SALES_ORDERS, useClass: HttpSalesOrdersService},
    {provide: CUSTOMERS, useClass: HttpCustomersService},
    {provide: ARTICLES, useClass: HttpArticlesService}
  ],
  declarations: [SalesOrderOverviewPageComponent, AddSalesOrderPageComponent, SelectCustomerComponent, SelectArticleComponent]
})
export class SalesOrderModule {}
